module.exports = __webpack_public_path__ + "media/images/guk15-9ab36ae6.png";